import { render, staticRenderFns } from "./updateEvacuation.vue?vue&type=template&id=6032142f"
import script from "./updateEvacuation.vue?vue&type=script&lang=js"
export * from "./updateEvacuation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports